import gql from 'graphql-tag';

export const RequestResetMfaEmail = gql`
  mutation RequestResetMfaEmail($email: String!) {
    requestResetMfaEmail(email: $email)
  }
`;
